import { useContext } from 'react';

import { useStore } from 'zustand';

import type { MergePurgeStore } from '@feat/reports/context/types/merge-purge-store.type';

import { MergePurgeContext } from '@feat/reports/context/merge-purge.context';

export const useMergePurgeStore = <TSelectorOutput>(selector: (store: MergePurgeStore) => TSelectorOutput) => {
  const store = useContext(MergePurgeContext);

  if (!store) {
    throw new Error('useMergePurgeStore must be used within a MergePurgeProvider');
  }

  return useStore(store, selector);
};
